import { socket } from '../core/socket.js';
import { state } from '../core/state.js';
import { t } from '../core/i18n.js';
import { popToast, chaosNotify } from '../utils/alerts.js';

let _mccGroupeId = null; 
let _chDragSrc = null;

// Variables de contexte partagées pour le clic droit
export let salonSelectionneId = null;
export let salonSelectionneNom = "";
export let salonSelectionneType = "";
export let groupeSelectionneId = null;
export let groupeSelectionneNom = "";

export function rejoindreSalon(id, nom, type) {
    const salonType = type || 'textuel';
    
    // --- CAS 1 : SALON VOCAL ---
    if (type === 'vocal') {
        if (typeof window.terminerAppelMPSiActif === 'function') window.terminerAppelMPSiActif();
        if (typeof window.quitterVocalVisuellement === 'function') window.quitterVocalVisuellement();
        
        const aura = document.getElementById('vocal-aura');
        if (aura) aura.classList.add('is-vocal-active');

        const infoPanel = document.getElementById('vocal-info-panel');
        if (infoPanel) infoPanel.style.display = 'block';
        const roomNameDisplay = document.getElementById('vocal-active-room-name');
        if (roomNameDisplay) roomNameDisplay.innerText = nom;

        const btnQuit = document.getElementById('vocal-disconnect-btn');
        if (btnQuit && typeof window.quitterVocal === 'function') {
            btnQuit.style.display = 'flex';
            btnQuit.onclick = window.quitterVocal;
        }
        if (typeof window.afficherSelfHangup === 'function') window.afficherSelfHangup(window.quitterVocal);

        const btnStream = document.getElementById('btn-stream');
        if (btnStream) btnStream.style.display = 'flex';

        localStorage.setItem('memoireVocalId', id);
        localStorage.setItem('memoireVocalNom', nom);
        if (typeof window.majBulleVocalRejoint === 'function') window.majBulleVocalRejoint();

        socket.emit('rejoindre-vocal', { salonId: id, pseudo: window.monPseudo });
        if (typeof window.activerMicro === 'function') window.activerMicro();
        return;
    }

    // --- CAS 2 : SALON TEXTUEL ---
    ouvrirChatSalon(id, nom);
}

export function ouvrirChatSalon(id, nom) {
    if (typeof window.sauvegarderDernierVu === 'function') window.sauvegarderDernierVu();
    if (typeof window.basculerAffichage === 'function') window.basculerAffichage('chat');

    const channels = document.getElementById('channels-column');
    if (channels) channels.classList.remove('open');
    if (typeof window.majPushChannels === 'function') window.majPushChannels();

    const inputArea = document.querySelector('.input-area');
    if (inputArea) inputArea.style.setProperty('display', 'block', 'important');

    // Synchronisation Ceinture + Bretelles pour app.js et le state
    window.salonActuelID = id; state.salonActuelID = id;
    window.destinataireID = null; state.destinataireID = null;
    
    if (window.sphereActuelleID && typeof window.enregistrerSalonSphere === 'function') {
        window.enregistrerSalonSphere(id, window.sphereActuelleID);
    }
    if (typeof window.resetBadgeSalon === 'function') window.resetBadgeSalon(id);
    
    const messagesUl = document.getElementById('messages');
    if (messagesUl) messagesUl.innerHTML = '';
    if (typeof window.resetSearch === 'function') window.resetSearch();

    const header = document.getElementById('chat-header');
    if (header) {
        header.innerHTML = t('chat.header_salon', { sphere: `<span style="opacity: 0.6;">${window.nomSphereActuelle}</span>`, salon: nom });
        header.style.color = "#f0f6fc";
    }
    if (typeof window.majVisibiliteRecherche === 'function') window.majVisibiliteRecherche(true);

    socket.emit('demander-historique-salon', id);
    
    const sphereIdActuel = window.sphereActuelleID || state.sphereActuelleID;
    const dataVue = { id: sphereIdActuel, nom: window.nomSphereActuelle, salonId: id, salonNom: nom };
    localStorage.setItem('derniereVue', JSON.stringify({ vue: 'sphere', data: dataVue }));

    if (window.sphereActuelleID) {
        try {
            const _mSalons = JSON.parse(localStorage.getItem('chaos_derniers_salons') || '{}');
            _mSalons[window.sphereActuelleID] = { salonId: id, salonNom: nom };
            localStorage.setItem('chaos_derniers_salons', JSON.stringify(_mSalons));
        } catch (e) {}
    }
}

export function majBoutonCreerSalon() {
    const btn = document.querySelector('.add-channel-btn');
    if (btn) btn.style.display = state.peutGererSalons ? '' : 'none';
}

export function ouvrirModalSalon(groupeId) {
    _mccGroupeId = groupeId || null;
    const radio = document.querySelector('input[name="mcc-type"][value="textuel"]');
    if (radio) radio.checked = true;
    const inputNom = document.getElementById('new-channel-name');
    if (inputNom) inputNom.value = '';
    majModalCreation();
    document.getElementById('modal-create-channel').style.display = 'flex';
    setTimeout(() => document.getElementById('new-channel-name')?.focus(), 80);
}

export function majModalCreation() {
    const type = document.querySelector('input[name="mcc-type"]:checked')?.value || 'textuel';
    const isGroupe = type === 'groupe';
    document.querySelectorAll('.mcc-type-card').forEach(card => {
        card.classList.toggle('selected', card.dataset.value === type);
    });
    document.getElementById('mcc-title').textContent = isGroupe ? 'Créer un groupe' : 'Créer un salon';
    document.getElementById('mcc-name-label').textContent = isGroupe ? 'Nom du groupe' : 'Nom du salon';
    document.getElementById('mcc-submit-btn').textContent = isGroupe ? 'Créer le groupe' : 'Créer le salon';
    document.getElementById('new-channel-name').placeholder = isGroupe ? 'ex: Informations' : 'ex: la-cantine';
}

export function fermerModalSalon() {
    document.getElementById('modal-create-channel').style.display = 'none';
    document.getElementById('new-channel-name').value = '';
}

export function validerCreationSalon() {
    const nom = document.getElementById('new-channel-name').value.trim();
    const type = document.querySelector('input[name="mcc-type"]:checked')?.value || 'textuel';
    
    const activeSphereId = window.sphereActuelleID || state.sphereActuelleID;
    
    if (!nom || !activeSphereId) return;
    
    if (type === 'groupe') {
        socket.emit('creer-groupe', { sphereId: activeSphereId, nom });
    } else {
        socket.emit('creer-salon', { nom, type, sphereId: activeSphereId, groupeId: _mccGroupeId });
    }
    fermerModalSalon();
}

export function ouvrirMenuGroupe(e, groupeId, groupeNom) {
    e.preventDefault(); e.stopPropagation();
    groupeSelectionneId = groupeId;
    groupeSelectionneNom = groupeNom;
    const menu = document.getElementById('groupe-context-menu');
    if (menu) {
        menu.style.display = 'block';
        menu.style.left = `${e.clientX}px`;
        menu.style.top  = `${e.clientY}px`;
    }
}

export function debutRenommerGroupeMenu() {
    document.getElementById('groupe-context-menu').style.display = 'none';
    if (!groupeSelectionneId) return;
    const el = document.querySelector(`.ch-groupe[data-groupe-id="${groupeSelectionneId}"] .ch-groupe-name`);
    if (el) _startInlineRename(el, groupeSelectionneId, groupeSelectionneNom);
}

function _startInlineRename(spanEl, groupeId, ancienNom) {
    const input = document.createElement('input');
    input.type = 'text'; input.className = 'ch-groupe-rename-input';
    input.value = ancienNom;
    spanEl.replaceWith(input);
    input.focus(); input.select();
    const terminer = () => {
        const nom = input.value.trim() || ancienNom;
        const span = document.createElement('span');
        span.className = 'ch-groupe-name';
        span.textContent = nom;
        span.ondblclick = (e) => { e.stopPropagation(); _startInlineRename(span, groupeId, nom); };
        input.replaceWith(span);
        if (nom !== ancienNom) socket.emit('renommer-groupe', { sphereId: window.sphereActuelleID, groupeId, nom });
    };
    input.onblur = terminer;
    input.onkeydown = (e) => {
        if (e.key === 'Enter')  { e.preventDefault(); terminer(); }
        if (e.key === 'Escape') { input.value = ancienNom; terminer(); }
    };
}

export async function confirmerSuppressionGroupe() {
    document.getElementById('groupe-context-menu').style.display = 'none';
    if (!groupeSelectionneId) return;
    const ok = await chaosNotify(`Supprimer le groupe « ${groupeSelectionneNom} » ? Les salons à l'intérieur doivent d'abord en être sortis.`, "Supprimer le groupe", "confirm");
    if (ok) socket.emit('supprimer-groupe', { sphereId: window.sphereActuelleID, groupeId: groupeSelectionneId });
}

export function creerGroupeDepuisSalon() {
    document.getElementById('channel-context-menu').style.display = 'none';
    ouvrirModalSalon();
    const radio = document.querySelector('input[name="mcc-type"][value="groupe"]');
    if (radio) { radio.checked = true; majModalCreation(); }
}

function _getCollapsed() {
    try { return JSON.parse(localStorage.getItem('chaos_groupes_collapsed') || '{}'); } catch(e) { return {}; }
}
function _setCollapsed(map) {
    try { localStorage.setItem('chaos_groupes_collapsed', JSON.stringify(map)); } catch(e) {}
}

export function toggleGroupe(groupeId) {
    const map = _getCollapsed();
    map[groupeId] = !map[groupeId];
    _setCollapsed(map);
    const body = document.getElementById(`groupe-body-${groupeId}`);
    const chevron = document.querySelector(`.ch-groupe[data-groupe-id="${groupeId}"] .ch-chevron`);
    if (body) body.classList.toggle('collapsed', !!map[groupeId]);
    if (chevron) chevron.classList.toggle('collapsed', !!map[groupeId]);
}

function _emettrereordonnerTout() {
    const container = document.getElementById('liste-salons');
    if (!container) return;
    const topLevel = [];
    const groupes = {};
    for (const child of container.children) {
        if (child.classList.contains('ch-groupe')) {
            const gid = parseInt(child.dataset.groupeId);
            topLevel.push({ type: 'groupe', id: gid });
            const body = child.querySelector('.ch-groupe-body');
            if (body) groupes[gid] = Array.from(body.querySelectorAll(':scope > .channel-item')).map(el => parseInt(el.dataset.salonId));
        } else if (child.classList.contains('channel-item')) {
            topLevel.push({ type: 'salon', id: parseInt(child.dataset.salonId) });
        }
    }
    socket.emit('reordonner-tout', { sphereId: window.sphereActuelleID, topLevel, groupes });
}

function _clearDragUI() {
    document.querySelectorAll('#liste-salons .ch-drop-line').forEach(l => l.remove());
    document.querySelectorAll('#liste-salons .drop-hover').forEach(h => h.classList.remove('drop-hover'));
}

function _attachDragSalon(div, body) {
    div.addEventListener('dragstart', (e) => {
        _chDragSrc = div;
        e.dataTransfer.effectAllowed = 'move';
        setTimeout(() => div.classList.add('ch-dragging'), 0);
    });
    div.addEventListener('dragend', () => {
        div.classList.remove('ch-dragging');
        _chDragSrc = null;
        _clearDragUI();
    });
    div.addEventListener('dragover', (e) => {
        e.preventDefault(); e.stopPropagation();
        if (!_chDragSrc || _chDragSrc === div) return;
        if (_chDragSrc.classList.contains('ch-groupe')) return; 
        _clearDragUI();
        const after = e.clientY > div.getBoundingClientRect().top + div.getBoundingClientRect().height / 2;
        const line = document.createElement('div'); line.className = 'ch-drop-line';
        div.insertAdjacentElement(after ? 'afterend' : 'beforebegin', line);
    });
    div.addEventListener('drop', (e) => {
        e.preventDefault(); e.stopPropagation();
        if (!_chDragSrc || _chDragSrc === div) return;
        if (_chDragSrc.classList.contains('ch-groupe')) return;
        _clearDragUI();
        const after = e.clientY > div.getBoundingClientRect().top + div.getBoundingClientRect().height / 2;
        div.insertAdjacentElement(after ? 'afterend' : 'beforebegin', _chDragSrc);
        _emettrereordonnerTout();
    });
}

function _attachDragGroupe(groupeDiv) {
    const header = groupeDiv.querySelector('.ch-groupe-header');
    groupeDiv.addEventListener('dragstart', (e) => {
        if (e.target.closest('.ch-groupe-body')) return; 
        _chDragSrc = groupeDiv;
        e.dataTransfer.effectAllowed = 'move';
        setTimeout(() => groupeDiv.classList.add('ch-dragging'), 0);
    });
    groupeDiv.addEventListener('dragend', () => {
        groupeDiv.classList.remove('ch-dragging');
        _chDragSrc = null;
        _clearDragUI();
    });
    header.addEventListener('dragover', (e) => {
        e.preventDefault(); e.stopPropagation();
        if (!_chDragSrc || !_chDragSrc.classList.contains('channel-item')) return;
        _clearDragUI();
        header.classList.add('drop-hover');
    });
    header.addEventListener('drop', (e) => {
        e.preventDefault(); e.stopPropagation();
        if (!_chDragSrc || !_chDragSrc.classList.contains('channel-item')) return;
        header.classList.remove('drop-hover');
        const body = groupeDiv.querySelector('.ch-groupe-body');
        if (body) {
            body.appendChild(_chDragSrc);
            body.classList.remove('collapsed');
        }
        const chevron = groupeDiv.querySelector('.ch-chevron');
        if (chevron) chevron.classList.remove('collapsed');
        _emettrereordonnerTout();
    });
    groupeDiv.addEventListener('dragover', (e) => {
        if (e.target.closest('.ch-groupe-body')) return;
        if (e.target.closest('.ch-groupe-header') && _chDragSrc?.classList.contains('channel-item')) return;
        e.preventDefault(); e.stopPropagation();
        if (!_chDragSrc || _chDragSrc === groupeDiv) return;
        if (_chDragSrc.classList.contains('channel-item')) return; 
        _clearDragUI();
        const after = e.clientY > groupeDiv.getBoundingClientRect().top + groupeDiv.getBoundingClientRect().height / 2;
        const line = document.createElement('div'); line.className = 'ch-drop-line';
        groupeDiv.insertAdjacentElement(after ? 'afterend' : 'beforebegin', line);
    });
    groupeDiv.addEventListener('drop', (e) => {
        if (e.target.closest('.ch-groupe-body')) return;
        if (e.target.closest('.ch-groupe-header') && _chDragSrc?.classList.contains('channel-item')) return;
        e.preventDefault(); e.stopPropagation();
        if (!_chDragSrc || _chDragSrc === groupeDiv) return;
        if (_chDragSrc.classList.contains('channel-item')) return;
        _clearDragUI();
        const after = e.clientY > groupeDiv.getBoundingClientRect().top + groupeDiv.getBoundingClientRect().height / 2;
        groupeDiv.insertAdjacentElement(after ? 'afterend' : 'beforebegin', _chDragSrc);
        _emettrereordonnerTout();
    });
}

export function renommerSalon() {
    document.getElementById('channel-context-menu').style.display = 'none';
    if (!salonSelectionneId) return;
    const modal = document.getElementById('modal-rename-channel');
    const input = document.getElementById('rename-channel-input');
    if (input) input.value = salonSelectionneNom;
    if (modal) modal.style.display = 'flex';
    setTimeout(() => document.getElementById('rename-channel-input')?.focus(), 100);
}

export function validerRenommageSalon() {
    const input = document.getElementById('rename-channel-input');
    const nouveauNom = input ? input.value : "";
    if (nouveauNom && nouveauNom.trim() !== "" && nouveauNom !== salonSelectionneNom) {
        const nomPropre = nouveauNom.trim().toLowerCase().replace(/\s+/g, '-');
        socket.emit('renommer-salon', { salonId: salonSelectionneId, nouveauNom: nomPropre, sphereId: window.sphereActuelleID });
        document.getElementById('modal-rename-channel').style.display = 'none';
    } else {
        document.getElementById('modal-rename-channel').style.display = 'none';
    }
}

export async function confirmerSuppressionSalon() {
    document.getElementById('channel-context-menu').style.display = 'none';
    if (!salonSelectionneId) return;
    const confirmation = await chaosNotify(t('confirm.delete_channel', { icon: salonSelectionneType === 'vocal' ? '🔊' : '#', name: salonSelectionneNom }), t('confirm.delete_channel_title'), "confirm");
    if (confirmation) {
        socket.emit('supprimer-salon', { salonId: salonSelectionneId, sphereId: window.sphereActuelleID });
        if (salonSelectionneId === window.salonActuelID) {
            const msgsUl = document.getElementById('messages');
            const header = document.getElementById('chat-header');
            if (msgsUl) msgsUl.innerHTML = '';
            if (header) header.innerHTML = t('chat.header_select');
            window.salonActuelID = null; state.salonActuelID = null;
        }
    }
}

export function privatiserSalon() {
    document.getElementById('channel-context-menu').style.display = 'none';
    chaosNotify(t('toast.privatize_wip'), "INFO SYSTÈME", "alert");
}

export function initChannelsSync() {
    // Écouteur principal de génération de la liste des salons
    socket.on('liste-salons', (items) => {
        const container = document.getElementById('liste-salons');
        if (!container) return;
        container.innerHTML = "";

        const peutReordonner = state.peutGererSalons;
        const collapsed = _getCollapsed();

        const tousLesSalons = items.flatMap(item => item.item_type === 'groupe' ? (item.salons || []) : [item]);

        function _creerItemSalon(salon, parentEl) {
            if (window.sphereActuelleID && typeof window.enregistrerSalonSphere === 'function') {
                window.enregistrerSalonSphere(salon.id, window.sphereActuelleID);
            }

            const div = document.createElement('div');
            div.className = `channel-item ${salon.type}`;
            div.dataset.salonId = salon.id;
            if (peutReordonner) div.draggable = true;

            const iconClass = salon.type === 'vocal' ? 'fa-volume-up' : 'fa-hashtag';
            const bulleVocal = salon.type === 'vocal'
                ? `<button class="vocal-chat-bubble" data-salon-id="${salon.id}" title="Discussion du vocal"><i class="fas fa-comment-dots"></i></button>`
                : '';

            div.innerHTML = `
                <i class="fas ${iconClass} ch-icon"></i>
                <span class="ch-name">${salon.nom}</span>
                <span class="channel-unread-badge" id="channel-badge-${salon.id}" style="display:none;"></span>
                ${bulleVocal}
                <div id="vocal-members-${salon.id}" class="vocal-members-list"></div>
            `;

            const bBtn = div.querySelector('.vocal-chat-bubble');
            if (bBtn) bBtn.onclick = (e) => { e.stopPropagation(); ouvrirChatSalon(salon.id, salon.nom); };

            div.onclick = (e) => {
                if (e.target.closest('.vocal-members-list')) return;
                if (e.target.closest('.vocal-chat-bubble')) return;
                container.querySelectorAll('.channel-item').forEach(c => c.classList.remove('active'));
                div.classList.add('active');
                rejoindreSalon(salon.id, salon.nom, salon.type);
            };

            div.oncontextmenu = (e) => {
                e.preventDefault(); e.stopPropagation();
                salonSelectionneId = salon.id; salonSelectionneNom = salon.nom; salonSelectionneType = salon.type;
                window.salonSelectionneId = salon.id;
                window.salonSelectionneNom = salon.nom;
                const menu = document.getElementById('channel-context-menu');
                if (menu) {
                    menu.style.display = 'block'; 
                    menu.style.left = `${e.clientX}px`; 
                    menu.style.top = `${e.clientY}px`;
                }
            };

            if (peutReordonner) _attachDragSalon(div, parentEl);
            parentEl.appendChild(div);
        }

        function _creerGroupe(item) {
            const gid = item.id;
            const isCollapsed = !!collapsed[gid];

            const groupeDiv = document.createElement('div');
            groupeDiv.className = 'ch-groupe';
            groupeDiv.dataset.groupeId = gid;
            if (peutReordonner) groupeDiv.draggable = true;

            const header = document.createElement('div');
            header.className = 'ch-groupe-header';
            header.innerHTML = `
                <i class="fas fa-chevron-right ch-chevron ${isCollapsed ? 'collapsed' : ''}"></i>
                <span class="ch-groupe-name">${item.nom}</span>
                ${peutReordonner ? `<button class="ch-groupe-menu-btn" title="Options du groupe"><i class="fas fa-ellipsis-h"></i></button>` : ''}
            `;
            header.onclick = (e) => {
                if (e.target.closest('.ch-groupe-menu-btn')) return;
                toggleGroupe(gid);
            };
            if (peutReordonner) {
                header.querySelector('.ch-groupe-name')?.addEventListener('dblclick', (e) => {
                    e.stopPropagation();
                    _startInlineRename(header.querySelector('.ch-groupe-name'), gid, item.nom);
                });
                const menuBtn = header.querySelector('.ch-groupe-menu-btn');
                if (menuBtn) menuBtn.onclick = (e) => ouvrirMenuGroupe(e, gid, header.querySelector('.ch-groupe-name')?.textContent || item.nom);
            }

            const body = document.createElement('div');
            body.className = `ch-groupe-body${isCollapsed ? ' collapsed' : ''}`;
            body.id = `groupe-body-${gid}`;

            (item.salons || []).forEach(salon => _creerItemSalon(salon, body));

            groupeDiv.appendChild(header);
            groupeDiv.appendChild(body);
            container.appendChild(groupeDiv);

            if (peutReordonner) _attachDragGroupe(groupeDiv);
        }

        items.forEach(item => {
            if (item.item_type === 'groupe') _creerGroupe(item);
            else _creerItemSalon(item, container);
        });

        if (window.salonActuelID) {
            const el = container.querySelector(`[data-salon-id="${window.salonActuelID}"]`);
            if (el) el.classList.add('active');
        }

        if (typeof window.appliquerBadgesSalons === 'function') window.appliquerBadgesSalons();

        if (window._pendingAutoNavSphere && tousLesSalons.length > 0) {
            window._pendingAutoNavSphere = false;
            try {
                const _mSalons = JSON.parse(localStorage.getItem('chaos_derniers_salons') || '{}');
                const _mem = window.sphereActuelleID && _mSalons[window.sphereActuelleID];
                const _cible = _mem ? tousLesSalons.find(s => s.id === _mem.salonId) : null;
                const _salon = _cible || tousLesSalons[0];
                if (_salon) setTimeout(() => rejoindreSalon(_salon.id, _salon.nom, _salon.type), 0);
            } catch(e) { window._pendingAutoNavSphere = false; }
        }

        setTimeout(() => { if (typeof window.dessinerAvatarsVocaux === "function") window.dessinerAvatarsVocaux(); }, 50);
        if (typeof window.majBulleVocalRejoint === 'function') window.majBulleVocalRejoint();
    });

    socket.on('salon-cree', (data) => {
        const activeSphereId = window.sphereActuelleID || state.sphereActuelleID;
        if (data.sphereId === activeSphereId) socket.emit('demander-salons', data.sphereId);
    });

    // Kick de sphère suite à un ban
    socket.on('forcer-quitter-salon', ({ salonId }) => {
        if (String(state.salonActuelID) === String(salonId)) {
            if (typeof window.basculerAffichage === 'function') window.basculerAffichage('dashboard');
        }
    });

    socket.on('maj-salons-sphere', (sphereId) => {
        const activeSphereId = window.sphereActuelleID || state.sphereActuelleID;
        if (activeSphereId === sphereId) socket.emit('demander-salons', sphereId);
    });
    
    // Branchement de l'interception de touche Entrée sur le renommage de salon
    document.getElementById('rename-channel-input')?.addEventListener('keypress', (e) => {
        if (e.key === 'Enter') validerRenommageSalon();
    });
}